import { Provider } from 'react-redux';

import { AuthCheck } from 'AuthPackage/MainModule/containers/AuthCheck';
import { UserOrganizationsCheck } from 'CorePackage/MainModule/components/UserOrganizationsCheck';
import { ErrorBoundary } from 'CorePackage/MainModule/components/ErrorBoundary';

import { store } from '../common/store';
import { CheckNotification } from './CheckNotification';
import { RenderRoutes } from './RenderRoutes';
import { Loader } from './Loader';

export const App = () => (
  <ErrorBoundary>
    <Provider store={store}>
      <AuthCheck>
        <UserOrganizationsCheck>
          <CheckNotification>
            <RenderRoutes />
            <Loader />
          </CheckNotification>
        </UserOrganizationsCheck>
      </AuthCheck>
    </Provider>
  </ErrorBoundary>
);
